import { Check, ListFilter, Search, VerifiedIcon, X } from "lucide-react";
import React, { useState } from "react";
import { Badge } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuCheckboxItem,
} from "@/components/ui/dropdown-menu";

interface SearchBarProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  selectedCategory: string;
  setSelectedCategory: (category: string) => void;
  availableCategories: string[];
}

const SearchBar: React.FC<SearchBarProps> = ({
  searchTerm,
  setSearchTerm,
  selectedCategory,
  setSelectedCategory,
  availableCategories,
}) => {
  return (
    <div className="flex flex-col p-4 gap-3">
      <div className="flex justify-between items-center gap-3">
        <div className="flex items-center gap-2 bg-[#1F1F22] border border-secondary rounded-md px-2 py-[6px] w-full">
          <Search size={18} className="text-[#8E8E8E]" />
          <input
            type="text"
            placeholder="Search Apps"
            className="bg-transparent text-sm border-none outline-hidden text-white placeholder:text-[#8E8E8E] w-full"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <div className="border border-secondary bg-[#1F1F22] rounded-md p-2 flex items-center gap-1 cursor-pointer">
              <ListFilter className="w-5 h-5 text-[#8E8E8E]" />
            </div>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="start"
            className="bg-[#131519] space-y-1 border border-[#2D2D30] w-[200px]"
          >
            {availableCategories.map((category) => (
              <DropdownMenuCheckboxItem
                key={category}
                checked={selectedCategory === category}
                onCheckedChange={() => setSelectedCategory(category)}
                className="text-sm text-white hover:bg-[#2D2D30] flex items-center"
              >
                {category}
                {category === "Featured" && (
                  <VerifiedIcon
                    fill="white"
                    className="w-4 h-4 ml-1 text-black"
                  />
                )}
              </DropdownMenuCheckboxItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      {/* Category chips area */}
      {selectedCategory !== "All" && (
        <div className="flex flex-wrap gap-2">
          <div className="border border-[#2D2D30] bg-[#2F3035] rounded-md px-2 py-1 flex items-center gap-2">
            <span className="text-white text-xs">{selectedCategory}</span>
            <X
              className="w-4 h-4 text-[#8E8E8E] hover:text-white cursor-pointer"
              onClick={() => setSelectedCategory("All")}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
